import { ProductReviewForm } from '@/features/factory/subfactories/ProductReviewForm'

/** Sub-route /factory/product-review — wraps the Product Review form. */
export function ProductReviewPage() {
  return <ProductReviewForm />
}
